import { makeStyles } from "@mui/styles";

const useStyles = () => {
  return makeStyles(() => ({
    optional: {
      lineHeight: "18px",
    },
    select: {
      paddingTop: 4,
      display: "flex",
      alignItems: "center"
    },
  }))();
};

export default useStyles;
